import useHomepageReset from "@hooks/useHomepageReset";

const RootHooks = ({ children }) => {
  // useHomepageReset();
  return children;
};

export default RootHooks;
